process.env.USE_MOCKS = true;
// process.env.http_proxy = 'http://127.0.0.1:8888';

const app = require('../../dist/app').default;

let ready = false;
app.on('ready', () => (ready = true));

before((done) => {
  if (ready) done();
});

after((done) => {
  app.emit('stop');
  done();
});
